import { render, staticRenderFns } from "./ReviewOrdersBarPlotByClient.vue?vue&type=template&id=12bfac5a"
import script from "./ReviewOrdersBarPlotByClient.vue?vue&type=script&lang=js"
export * from "./ReviewOrdersBarPlotByClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports